import React, { MouseEventHandler } from 'react';

import { Button, Form, FormProps, Input } from 'antd';
import styled from '@emotion/styled';

const StyledForm = styled(Form)`
  > .ant-form-item {
    &:nth-of-type(2) {
      margin-bottom: 8px;
    }
    .ant-form-item-explain-error {
      text-align: left;
    }
  }
`;

export const ForgotPasswordForm = ({
  ...props
}: Partial<
  FormProps & {
    onForgotPassword: MouseEventHandler;
  }
>) => {
  const [form] = Form.useForm();
  return (
    <StyledForm
      name="forgot-password-form"
      form={form}
      layout="vertical"
      autoComplete="off"
      {...props}
    >
      <Form.Item
        label="Email"
        name="email"
        rules={[
          {
            type: 'email',
            required: true,
            message: 'Email is invalid'
          }
        ]}
      >
        <Input></Input>
      </Form.Item>

      <Button htmlType="submit" block type="primary" size="middle">
        RESET MY PASSWORD
      </Button>
    </StyledForm>
  );
};
